import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Popover extends Component {
	render () {
		return (
			<div className="popover">
				<div className="arrow"></div>
				<h3 className="popover-title">{this.props.title}</h3>
				<div className="popover-content">
					{this.props.children}
				</div>
			</div>
		);
	}
}

Popover.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node
};

export default Popover;



// WEBPACK FOOTER //
// ./components/Popover.js